<template>
    <div>
        <p class="label">{{ label }}</p>
        <v-autocomplete
                v-model="pickedId"
                :items="items"
                item-value="id"
                item-text="name"
                outlined
                hide-no-data
                :loading="isLoading"
                @change="onInput"
                hide-details="auto"
                class="mb-4"
                v-bind="$attrs"
        >
            <template v-slot:selection="{ item, index }">
                <span
                        v-if="index === 0"
                        class="grey--text caption"
                >
                    <template>1 item</template>
                </span>
            </template>
        </v-autocomplete>

        <v-flex xs12 sm12 md12 v-if="pickedItem">
            <v-flex xs12>
                <v-card class="filter-selected my-0" color="#F8F8F8" outlined tile elevation="0">
                    <template>
                        <v-chip
                                close-icon="$close"
                                close
                                outlined
                                label
                                color="#202020"
                                class="mr-2 my-1"
                                @click:close="unpick()"
                        >
                            <span class="body-2">{{ pickedItem.name }}</span>
                        </v-chip>
                    </template>
                </v-card>
            </v-flex>
        </v-flex>
    </div>
</template>

<script>
  export default {
    name: "DegreeTypePickerInput",
    props: {
      value: {},
      label: {type: String, default: 'Degree type'},
      placeholder: {type: String, default: 'Select...'},
      hideLabel: { type: Boolean, default: false},
    },
    data() {
      return {
        items: [],
        pickedId: null,
        isLoading: false
      }
    },
    computed: {
      pickedItem() {
        return this.items.find((item) => item.id === this.pickedId);
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        if (this.isLoading) return;

        this.isLoading = true;

        const _this = this;

        _this.items = [
          {
            id: 3,
            name: 'De BAC à BAC+3'
          },
          {
            id: 1,
            name: 'De BAC+3 à BAC+6'
          }
        ];

        _this.isLoading = false;
      },
      unpick() {
        this.$emit('input', null);
      },
      onInput(value) {
        this.$emit('input', value);
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          this.pickedId = value;
        }
      }
    }
  }
</script>

<style scoped>

</style>
